import { Box, Stack } from "@mui/material";
import { InputModalContentLayout } from "../common/InputModalContentLayout";
import {
  SearchMaterialPhysics,
  SearchMaterials,
} from "contexts/search/context";
import { Loaded, liftLoadedState } from "models/loaded";
import { LoadedContent } from "src/components/common/loading/loadedContent";
import { ObtainableBundleItem } from "store/api/generatedApi";
import { ImportAvailabilityFromSearchButton } from "./ImportFromSearch";
import { AvailabilitiesTable } from "./AvailabilitiesTable";
import { useState } from "react";
import { DeleteAvailabilitiesButton } from "./DeleteAvailabilitiesButton";
import {
  useMaterialPhysics,
  useMaterials,
} from "contexts/search/SearchContextProvider";
import { usePeriodIndex } from "hooks/periodIndex";
import { useObtainableBundles } from "hooks/search";

export const AvailabilitiesEditor = () => {
  const [selectedItemIds, setSelectedItemIds] = useState<string[]>([]);

  return (
    <LoadedContent data={useDependencies()} enableFullHeight>
      {({ materials, materialPhysics, obtainableBundles }) => (
        <InputModalContentLayout
          topPanel={
            <Stack gap={2}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Stack spacing={1} direction="row">
                  {selectedItemIds.length > 0 && (
                    <DeleteAvailabilitiesButton
                      materials={materials}
                      selectedItemIds={selectedItemIds}
                      setSelectedItemIds={setSelectedItemIds}
                    />
                  )}
                  <ImportAvailabilityFromSearchButton />
                </Stack>
              </Box>
            </Stack>
          }
          leftPanel={
            <AvailabilitiesTable
              materials={materials}
              materialPhysics={materialPhysics}
              obtainableBundleItems={obtainableBundles}
              selectedItemIds={selectedItemIds}
              setSelectedItemIds={setSelectedItemIds}
            />
          }
          fullWidthLeftPanel
          removeLeftPanelOutline
        />
      )}
    </LoadedContent>
  );
};

const useDependencies = (): Loaded<{
  materials: SearchMaterials;
  materialPhysics: SearchMaterialPhysics;
  obtainableBundles: ObtainableBundleItem[];
}> => {
  const materials = useMaterials();
  const materialPhysics = useMaterialPhysics();
  const periodTab = usePeriodIndex();
  const [obtainableBundles] = useObtainableBundles(periodTab);

  return liftLoadedState({ materials, materialPhysics, obtainableBundles });
};
